module.exports = __webpack_public_path__ + "static/media/SumoBkgSplash.88fe2a70.png";